module.exports = __WEBPACK_EXTERNAL_MODULE__reach_router__;